import type { ReactElement } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { messageErreur } from '../api/error-message';

/**
 * Notes de version, lues du CHANGELOG (source de vérité).
 *
 * Écrites pour les personnes qui utilisent l'outil : ce que la version change
 * dans leur travail, pas ce qu'elle change dans le code. Ouvertes à tous les
 * rôles — savoir quelle version on utilise n'est pas un privilège.
 */
export function NotesDeVersionPage(): ReactElement {
  const version = useQuery({ queryKey: ['version'], queryFn: () => api.version() });

  return (
    <>
      <h1>Notes de version</h1>

      {version.isPending && <p className="chargement">Chargement des notes…</p>}
      {version.isError && (
        <p className="alerte alerte--erreur" role="alert">
          {messageErreur(version.error)}
        </p>
      )}

      {version.data && (
        <>
          <p className="sous-titre">
            Version en service : <strong>{version.data.version}</strong>
          </p>

          {version.data.notes.length === 0 ? (
            <p className="alerte alerte--info" role="status">
              Aucune note de version n&apos;est disponible sur cette installation.
            </p>
          ) : (
            version.data.notes.map((entree) => (
              <div className="carte" key={entree.version}>
                <h2>
                  {entree.version}
                  {entree.date && <span className="titre-secondaire"> — {entree.date}</span>}
                </h2>
                <ul className="liste-nouveautes">
                  {entree.nouveautes.map((nouveaute, rang) => (
                    <li key={rang}>{nouveaute}</li>
                  ))}
                </ul>
              </div>
            ))
          )}
        </>
      )}
    </>
  );
}
